// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1_ZrW","label":"SetPasswdForm_label__1uO9x"};